import { Component, Output, Input, EventEmitter } from '@angular/core';
import { IGalleryItem } from '@common/models/gallery-item';
import { UrlBuilderService } from '@common/services/url-builder.service';

@Component({
  selector: 'mojo-property-gallery',
  templateUrl: './property-gallery.component.html'
})
export class PropertyGalleryComponent {
  _galleryItems: IGalleryItem[];

  @Input()
  get galleryItems(): IGalleryItem[] {
    return this._galleryItems;
  }

  set galleryItems(newValue) {
    this._galleryItems = newValue;
    if (this._activeIndex + 1 > this._galleryItems.length) {
      this.activeIndex = this._galleryItems.length -1;
    } else {
      this.activeIndex = this.previousIndex;
    }
  }

  @Input() showThumbnails = false;

  private _activeIndex = 0;

  @Input()
  get activeIndex(): number {
    return this._activeIndex;
  }

  set activeIndex(newValue) {
    this.previousIndex = this._activeIndex;
    this._activeIndex = newValue;
    this.activeIndexChange.emit(newValue);
  }


  @Output() mouseEnter = new EventEmitter();

  @Output() mouseLeave = new EventEmitter();

  @Output() dragover = new EventEmitter<any>();

  @Output() activeIndexChange = new EventEmitter<number>();

  previousIndex = 0;


  constructor(private readonly urlBuilderService: UrlBuilderService) {}

  getPropertyPictureUrl(item: IGalleryItem): string {
    if (item != undefined) {
      return this.urlBuilderService.getUrl(`property/picture/${item.DocumentKey.Uri}`);
    }
    return undefined;
  }

  mouseEnterEvent() {
    this.mouseEnter.emit();
  }

  mouseLeaveEvent() {
    this.mouseLeave.emit();
  }

  dragoverEvent(event) {
    this.dragover.emit(event);
  }
}

